/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buffer Recipe Calculator (TBS, PBS, Western Blot) — Toolverse`)
};

const es_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Recetas de Buffer (TBS, PBS, Western Blot) — Toolverse`)
};

const de_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pufferrezept-Rechner (TBS, PBS, Western Blot) — Toolverse`)
};

const nl_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buffer-receptcalculator (TBS, PBS, Western Blot) — Toolverse`)
};

const fr_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de recettes de tampon (TBS, PBS, Western Blot) — Toolverse`)
};

const it_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore ricette buffer (TBS, PBS, Western Blot) — Toolverse`)
};

const pt_br2_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Receitas de Tampão (TBS, PBS, Western Blot) — Toolverse`)
};

const pt_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Receitas de Tampão (TBS, PBS, Western Blot) — Toolverse`)
};

const ja_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッファーレシピ計算機(TBS、PBS、ウエスタンブロット) — Toolverse`)
};

const zh_buf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缓冲液配方计算器（TBS、PBS、Western Blot） — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_meta_title", locale)
	if (locale === "en") return en_buf_meta_title(inputs)
	if (locale === "es") return es_buf_meta_title(inputs)
	if (locale === "de") return de_buf_meta_title(inputs)
	if (locale === "nl") return nl_buf_meta_title(inputs)
	if (locale === "fr") return fr_buf_meta_title(inputs)
	if (locale === "it") return it_buf_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_buf_meta_title(inputs)
	if (locale === "pt") return pt_buf_meta_title(inputs)
	if (locale === "ja") return ja_buf_meta_title(inputs)
	return zh_buf_meta_title(inputs)
};